// Lightweight loan-officer team store. Mirrors the LeadsStore event-bus
// pattern so any component can subscribe via the `useTeam()` hook without
// each consumer triggering its own fetch.

import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/team`;

const state = {
  members: [],
  loaded: false,
  loading: false,
};

const listeners = new Set();
const emit = () => { listeners.forEach((l) => l(state.members)); };

async function fetchAll() {
  if (state.loading) return state.members;
  state.loading = true;
  try {
    const r = await axios.get(API);
    state.members = Array.isArray(r.data) ? r.data : [];
    state.loaded = true;
    emit();
    return state.members;
  } catch (e) {
    console.error('Team fetch failed', e);
    return state.members;
  } finally {
    state.loading = false;
  }
}

// Public API
export const TeamStore = {
  all: () => state.members,
  get: (id) => state.members.find((m) => m.id === id) || null,
  subscribe: (cb) => { listeners.add(cb); return () => listeners.delete(cb); },
  refresh: fetchAll,
};

export function useTeam() {
  const [members, setMembers] = useState(state.members);
  useEffect(() => {
    if (!state.loaded && !state.loading) fetchAll();
    return TeamStore.subscribe(setMembers);
  }, []);
  return members;
}
